import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { NotificationAggregate } from '../aggregate/notification-aggregate';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
var NOTIFICATION_AGGREGATE_KEY = 'mainUserInfoAggregate';
var NotificationDomainService = /** @class */ (function () {
    /**
     * 基础service和request依赖ark统一注入，保证项目全局唯一
     */
    function NotificationDomainService(docMetaDomainService, networkRequest) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequest = networkRequest;
        this.notificationAggregate = new NotificationAggregate(NOTIFICATION_AGGREGATE_KEY, docMetaDomainService, networkRequest);
    }
    /**
     * 初始化通知领域
     */
    NotificationDomainService.prototype.init = function (requestParam) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.docMetaDomainService.init(requestParam)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], NotificationDomainService.prototype, "init", null);
    NotificationDomainService = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], NotificationDomainService);
    return NotificationDomainService;
}());
export { NotificationDomainService };
